import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useParams, Link } from 'react-router-dom';
import api from '../services/api';
import { getMediaUrl } from '../services/api';

const GalleryDetail = () => {
  const { slug } = useParams();
  const [gallery, setGallery] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadGallery();
  }, [slug]);

  const loadGallery = async () => {
    try {
      const response = await api.get(`/gallery/${slug}/`);
      setGallery(response.data);
    } catch (error) {
      console.error('Error loading gallery:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Container className="text-center py-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </Container>
    );
  }

  if (!gallery) {
    return (
      <Container className="py-5">
        <h1>Gallery Not Found</h1>
        <Link to="/gallery" className="btn btn-primary">Back to Gallery</Link>
      </Container>
    );
  }

  return (
    <Container className="py-5">
      <h1 className="page-title">{gallery.title}</h1>
      <p className="text-center text-muted mb-5">{gallery.description}</p>
      
      <Row>
        {gallery.images && gallery.images.map(image => (
          <Col key={image.id} md={4} sm={6} className="mb-4">
            <div className="gallery-image">
              <img 
                src={getMediaUrl(image.image)} 
                alt={image.caption || gallery.title}
                className="img-fluid rounded"
                style={{ width: '100%', height: '250px', objectFit: 'cover' }}
              />
              {image.caption && (
                <p className="text-center mt-2 small text-muted">{image.caption}</p>
              )}
            </div>
          </Col>
        ))}
      </Row>
      
      <div className="mt-4 text-center">
        <Link to="/gallery" className="btn btn-outline-primary">← Back to Gallery</Link>
      </div>
    </Container>
  );
};

export default GalleryDetail;
